import { render, staticRenderFns } from "./srcset.vue?vue&type=template&id=1ed1c710&"
import script from "./srcset.vue?vue&type=script&lang=js&"
export * from "./srcset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports